<script>
  import Selector from '../lib/components/Selector.svelte';
  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';
  import session from '../lib/session';
  import { APIClient } from '../state-charts';
  import InputField from '../lib/components/InputField.svelte';
  import _ from 'lodash';

  // component options  ------------------------------------------------------ //

  export let id = 'merchant_uuid';
  export let name;
  export let private_id = 'private_id';
  export let value;
  export let sort_service = false;
  export let list_items;
  export let is_registered = false;
  export let valid_private_code = true;
  export let show_hover_tooltip = false;
  export let width = '350px';
  export let default_private_code = false;
  export let is_invite;
  export let valid = true;
  export let invalid_text;
  export let list_state = 'default'; // 'public' , 'private'

  // internal variables ------------------------------------------------------ //

  export let items = [];
  let private_merchants = [];
  export let private_merchant_code;
  let private_merchant_code_field;
  let valid_input = true;
  let private_focused = false;
  let private_code_timer;
  let private_code_timer_flag = true;

  export let show_private_merchant_code_field = false;
  let merchants_loaded = false;

  // translated strings ------------------------------------------------------ //

  let init_code = false;
  let merchant_selector_label;
  let merchant_no_choice_text;
  let private_service_choice_label;
  let private_merchant_code_label;
  let private_merchant_name_label;
  let type_text;
  let private_merchant_option = {
    val: 'private',
    name: private_service_choice_label,
    seq: 100000,
    description: 'private service option',
  };
  let disabled = false;
  let running_code = false;

  // utility functions -------------------------------------------------------- //

  const get_user_country = () => {
    return $session.merchant.country_code;
  };

  const order_by_sequence_number = merchants => {
    const by_sequence_number = (m1, m2) => {
      return m1.seq < m2.seq ? -1 : m1.seq === m2.seq ? 0 : 1;
    };

    return merchants.sort(by_sequence_number);
  };

  const is_merchant_registered = merchant_uuid => {
    return $session.user.registered_merchants.some(
      m => m.uuid === merchant_uuid
    );
  };

  const apply_restriction_for_subdomain = session => {
    if (session.merchant_subdomain && session.merchant) {
      items = [
        ...items,
        {
          val: session.merchant.merchant_uuid,
          name: session.merchant.service.selection_name,
          seq: session.merchant.service.sequence_number,
          description: session.merchant.description,
        },
      ];
      value = !!session.merchant ? session.merchant.merchant_uuid : null;
      disabled = true;
    }
  };

  const load_merchants = () => {
    merchants_loaded = true;

    items = order_by_sequence_number($session.api_config.merchants).map(
      item => {
        if (sort_service === false) {
          if (
            item.service &&
            item.service.private_service &&
            item.service.private_service === true
          ) {
            private_merchants.push(item);
            return null;
          } else {
            return {
              val: item.uuid,
              name: item.selection_name,
              seq: item.sequence_number,
              description: item.description,
            };
          }
        } else {
          if (is_merchant_registered(item.merchant_uuid) === false) {
            if (item.country_code === get_user_country()) {
              if (item.service.private_service === true) {
                private_merchants.push(item);
                return null;
              } else {
                return {
                  val: item.merchant_uuid,
                  name: item.service.selection_name,
                  seq: item.service.sequence_number,
                  description: item.description,
                };
              }
            }
          }
        }
      }
    );


    if(list_state === 'default'){
      items = [private_merchant_option, ...items];
      items = items.filter(item => item !== null && typeof item !== 'undefined');
      items = order_by_sequence_number(items);
    }
    if(list_state === 'public'){
      items = [...items];
      items = items.filter(item => item !== null && typeof item !== 'undefined');
      items = order_by_sequence_number(items);
    }
    if(list_state === 'private') {
      value = 'private'
      items = [private_merchant_option];
      name = '';
      disabled = true;
    }
  };

  const load_external_merchant_list = merchant_list => {
    items = order_by_sequence_number(
      merchant_list.map(item => {
        return {
          val: item.merchant_uuid,
          name: item.selection_name,
          seq: item.sequence_number,
          description: item.description,
        };
      })
    );

    items = [...items, private_merchant_option];
  };

  const set_private_code_visibility = value => {
    if(list_state === 'private'){
      show_private_merchant_code_field = true;
    }  else{
      show_private_merchant_code_field = value === 'private';
    }
  };

  const handle_private_merchant_code_change = async e => {
    if(private_code_timer_flag){
    const merchant = await APIClient.get_merchant_for_code(e.target.value);


      if (!!merchant) {
        valid_private_code = true;
        show_private_merchant_code_field = false;
        private_merchant_code = null;
        let check_uuid = obj => obj.val === merchant.merchant_uuid;
        let is_added = items.some(check_uuid);

        if (!is_added) {
          items = order_by_sequence_number([
            {
              val: merchant.merchant_uuid,
              name: merchant.selection_name,
              seq: merchant.sequence_number,
              description: merchant.description,
              subdomain: merchant.subdomain,
            },
            ...items,
          ]);
        }

        value = merchant.merchant_uuid;
        name = merchant.name;

        private_code_timer_flag = false;
        private_code_timer = setTimeout(() => {
          clearTimeout(private_code_timer);
          private_code_timer_flag = true;
        }, 1000);
      } else {
        valid_private_code = false;
        if(list_state === 'private') value = 'private';
      }
    }

  };

  const set_name = value => {
    const merchant = items.find(i => i.val === value);
    if (merchant) {
      name = merchant.name;
    }
  };

  const set_private_name = () => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].val === 'private')
        items[i].name = private_merchant_code_label;
    }
  };

  const validate_input = (valid_code, val, merchant_code) => {
    if(private_focused){
      if (!valid_code) {
        valid_input = false;
      } else {
        valid_input = true;
      }
    }

  };

  // reactive functions ------------------------------------------------------- //

  $: set_name(value);

  $: validate_input(valid_private_code, value, private_merchant_code);

  // $: if(value) valid_private_code = true;
  $: {
    merchant_selector_label = t9n(TS.MERCHANT_LABEL_SERVICE);
    merchant_no_choice_text = t9n(TS.MERCHANT_LABEL_SELECT_SERVICE);
    private_service_choice_label = t9n(TS.MERCHANT_LABEL_PRIVATE_SERVICE);
    private_merchant_code_label = t9n(TS.MERCHANT_LABEL_PRIVATE_CODE);
    private_merchant_name_label = t9n(TS.MERCHANT_LABEL_PRIVATE_NAME);
    type_text = t9n(TS.NATIVE_SELECT_START_TYPE_TEXT);
  }

  $: if (
    !merchants_loaded &&
    $session &&
    $session.api_config &&
    $session.api_config.merchants
  ) {
    load_merchants();
  }

  $: if (list_items) load_external_merchant_list(list_items);

  $: if (merchants_loaded){
    set_private_name();
  }



  $: if(is_invite && !init_code){
    if(!!private_merchant_code){

      (async () => {
        value = 'private';
        await handle_private_merchant_code_change({target: { value: private_merchant_code }})
      })();
    } else{
      set_name(value);
    }

    init_code = true;
  }

  $: set_private_code_visibility(value);

  $: apply_restriction_for_subdomain($session);
</script>

  <div style="margin-bottom: -5px">
    {#if list_state !== 'private'}
    <div class="native-sel-width" >
      <Selector
        {id}
        label={merchant_selector_label}
        height={320}
        is_required={true}
        valid={valid}
        {list_state}
        invalid_text={invalid_text}
        bind:show_hover_tooltip
        bind:input_value={name}
        {items}
        bind:value
        {disabled} />
    </div>
    {/if}


    <div
      class="{!show_private_merchant_code_field ? 'rolled-up' : ''}
    service-code-field">

      <InputField
        id={private_id}
        type="text"
        label={private_merchant_code_label}
        name="private_merchant_code"
        is_required={true}
        bind:value={private_merchant_code}
        margin_bottom="7px"
        validation_text={t9n('error_not_found')}
        valid={valid_input}
        disabled={!private_code_timer_flag}
        margin_top="21px"
        bind:has_focused={private_focused}
        {width}
        on:keyup={async (e) => {
          if(!running_code){
            running_code = true;
            let debounce_fun = _.debounce(async () => {
               await handle_private_merchant_code_change(e)
              running_code = false;
            }, 1500);

            debounce_fun();
          }
        } } />
    </div>

    {#if list_state === 'private'}
      <div style='margin-top: 5px'>
        <InputField
          id={`label_${private_id}`}
          type="text"
          label={private_merchant_name_label}
          bind:value={name}
          width='350px'
          hide_bg={false}
          disabled={true} />
      </div>

    {/if}
  </div>


<style>
  .rolled-up {
    visibility: hidden;
    height: 0px;
  }

  #private-registration-input {
    opacity: 1;
    transition: opacity 1s;
  }

  #private-registration-input.fade {
    opacity: 0;
  }

  .service-code-field {
    transition: 0.5s all;
    overflow: hidden;
    margin-top: 5px;
  }

  .service-code-field:not(.rolled-up) {
    /*height: 75px;*/
    padding-top: 6px;
    margin-top: -9px;
  }

  @media (min-width: 1025px) {
    .native-sel-width {
      width: 100% !important;
    }
  }

  /* Tablet Mode
      *******************************************************/
  @media (min-width: 840px) and (max-width: 1024px) {
    .native-sel-width {
      width: 100% !important;
    }
  }

  /* Mobile Mode
      *******************************************************/
  @media (min-width: 0) and (max-width: 839px) {
    .native-sel-width {
      width: 100% !important;
    }
  }
</style>
